import { useEffect, useRef } from "@max/max";
import { mtShare } from "@max/meituan-uni-mtShare";
import { WX_MINI_APP, WX_MINI_APP_RAW_ID } from './types';
import Tools from '@nibfe/mp-webview-tools';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { isMiniProgramOrWebview, isTitansAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from "@nibfe/mkt-env-api";
import { appendParams, convertLinkToAppMiddleOpenLink } from "../../utils/common";
import { getUserInfo } from "@nibfe/mkt-user-api";
// import { KNB } from '@nibfe/mkt-common-utils';
// import { useQRCodePopup } from "../useQRCodePopup";
import { ShareType } from "./types";
import { navigateTo } from "@max/meituan-uni-navigate";
export function useShare(shareType = ShareType.WX_CARD) {
    const wxShareTool = useRef();
    const pikeConnected = useRef(false);
    const ctx = useMonitorEngineContext();
    const queryParams = ctx._runtimeInfo?.queryParams || {};
    // const { openQRCodePopup } = useQRCodePopup();
    const isInApp = isTitansAppOrWebview();
    const isInWX = isWeixinMiniProgramOrWeixinWebview();
    const isInWxMiniProgram = isWeixinMiniProgramOrWeixinWebview() && isMiniProgramOrWebview();
    const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
    async function createWxTool() {
        const userInfo = await getUserInfo();
        if (userInfo?.userId && !wxShareTool.current) {
            const wxTool = new Tools({
                userInfo: {
                    userId: userInfo.userId,
                    unionId: userInfo.unionId || queryParams.unionId,
                    token: userInfo.token,
                    userType: /** Meituan */ 1
                }
            });
            wxTool.on('share', () => { });
            wxTool.currPikeInstance?.onDisconnect(() => {
                pikeConnected.current = false;
            });
            wxShareTool.current = wxTool;
            pikeConnected.current = true;
        }
    }
    useEffect(() => {
        if (isInWX) {
            createWxTool();
        }
    }, []);
    async function shareWXCard(options) {
        const { params = {}, wxMiniApp = WX_MINI_APP.HOTEL, onSuccess, shareConfig } = options || {};
        const { shareUrl, shareContent, shareTitle, shareImg } = shareConfig || {};
        const url = appendParams(shareUrl || '', {
            isFromShare: 'true',
            ...params
        });
        if (shareType === ShareType.CALL_LINK) {
            await mtShare({
                type: 0,
                content: shareContent || '分享内容',
                title: shareTitle || '分享标题',
                imageUrl: shareImg || '',
                url: convertLinkToAppMiddleOpenLink(url)
            });
            onSuccess?.();
            return;
        }
        if (shareType === ShareType.H5_LINK) {
            if (isInApp) {
                await mtShare({
                    type: 0,
                    content: shareContent || '分享内容',
                    title: shareTitle || '分享标题',
                    imageUrl: shareImg || '',
                    url
                });
                onSuccess?.();
            }
            if (isInWxWebview) {
                navigateTo({
                    url: convertLinkToAppMiddleOpenLink(url)
                });
            }
            else {
                navigateTo({
                    url: convertLinkToAppMiddleOpenLink(url)
                });
            }
            return;
        }
        function miniProgramShare() {
            const shareData = {
                imgUrl: shareImg,
                uri: url,
                title: shareTitle,
                desc: shareContent
            };
            if (wxShareTool.current) {
                if (pikeConnected.current) {
                    wxShareTool.current.action('share', shareData).catch(e => {
                        ctx._raptorReport?.monitorReportLog('分享失败', e, {
                            level: 'warn',
                            category: 'mcp-use-monitor',
                            tags: {
                                name: '微信分享动作失败'
                            }
                        });
                        window?.wx?.miniProgram?.postMessage({
                            data: shareData
                        });
                        wxShareTool.current?.postMessage('share', shareData);
                        ctx._uiInteractionAPI.toast.show({
                            content: '分享失败，点击小程序更多按钮'
                        });
                    });
                    setTimeout(() => {
                        wxShareTool.current.action(1, shareData).catch(e => {
                            ctx._raptorReport?.monitorReportLog('分享失败', e, {
                                level: 'warn',
                                category: 'mcp-use-monitor',
                                tags: {
                                    name: '微信分享动作失败'
                                }
                            });
                        });
                        setTimeout(() => {
                            onSuccess?.();
                        }, 1000);
                    }, 0);
                    wxShareTool.current.on('share', () => {
                        onSuccess?.();
                    });
                }
                else {
                    wxShareTool.current.postMessage('share', shareData);
                    window?.wx?.miniProgram?.postMessage({
                        data: shareData
                    });
                    ctx._uiInteractionAPI.toast.show({
                        content: '分享失败，请稍后重试～'
                    });
                }
            }
            else {
                window?.wx?.miniProgram?.postMessage({
                    data: shareData
                });
                ctx._uiInteractionAPI.toast.show({
                    content: '分享失败，请稍后重试～'
                });
            }
        }
        if (isInWX) {
            miniProgramShare();
        }
        else if (isInApp) {
            const appId = WX_MINI_APP_RAW_ID[wxMiniApp];
            let path = '';
            switch (wxMiniApp) {
                case WX_MINI_APP.MT:
                    path = `/hotel/pages/h5/index?q=${encodeURIComponent(url)}`;
                    break;
                case WX_MINI_APP.HOTEL:
                    path = `/pages/h5/index?q=${encodeURIComponent(url)}`;
                    break;
                default:
                    ctx._uiInteractionAPI.toast.show({
                        content: '分享失败，请稍后重试～'
                    });
                    return;
            }
            await mtShare({
                type: 1,
                appId,
                path,
                url,
                content: shareContent || '分享内容',
                title: shareTitle || '分享标题',
                imageUrl: shareImg
            });
            onSuccess?.();
        }
        else {
            ctx._raptorReport?.monitorReportLog('分享失败', '环境异常', {
                level: 'warn',
                category: 'mcp-use-monitor',
                tags: {
                    name: '分享失败'
                }
            });
            ctx._uiInteractionAPI.toast.show({
                content: '请在美团App或微信内打开'
            });
        }
    }
    return {
        shareWXCard
    };
}
